// export const purple = '#4263F7'
export const purple = "#00c8d2";
export const purpleDark = "#2810D8";

// export const ocean = '#38D3EC'
export const ocean = "#00c8d2";
export const orange = "#e96900";

// export const main = '#272833'
export const main = "#2c3e50";
export const primary = "#37f";
export const white = "#FFFFFF";
export const grayExtraLight = "#f8f8f8";
export const grayLight = "#f0f4f7";
export const gray = "#BEC6CB";
export const grayDark = "#8492A6";
export const dark = "#13161F";
export const darkLight = "rgb(202, 202, 202)";

export const text = main;
// export const link = '#50DED8'
// export const link = ocean
export const link = primary;
export const background = white;
export const border = grayLight;

export const theadColor = gray;
export const theadBg = grayExtraLight;
export const tableColor = dark;
